/**
 * Forces logout for unauthorized users (clients or disabled users).
 * Clears session storage and triggers logout flow.
 *
 * This is used when:
 * 1. A user with role "client" logs in on another application that shares cookies:
 *    this application automatically recognizes the user via cookies, but does not
 *    allow login for users with role "client", so logout must be forced.
 * 2. User's account is disabled.
 *
 * @param store - The MobX store instance
 */
export const forceLogoutUnauthorizedUser = (store: { forceLogout: (value: boolean) => void }) => {
  sessionStorage.removeItem('searchText');
  sessionStorage.removeItem('tableSelectedTab');
  sessionStorage.removeItem('activeFilters');
  sessionStorage.removeItem('activeTimeFrames');
  sessionStorage.removeItem('apartmentFilters');
  sessionStorage.removeItem('loggedUserRole');
  store.forceLogout(true);
};
